import React from 'react';

import { white } from '@crehana/ui/dist/styles/colors';
import { useTranslation } from '@crehana/i18n';

import { FeaturesSectionItemProps } from './types';
import { getIconComponent } from './utils';

const FeaturesSectionItem: React.FC<
  React.PropsWithChildren<FeaturesSectionItemProps>
> = ({ feature }) => {
  const DynamicPictogram = getIconComponent(feature.icon);
  const { t } = useTranslation();

  return (
    <div>
      {DynamicPictogram && (
        <DynamicPictogram
          className="mb-20"
          color={white}
          secondaryColor={white}
          size={48}
        />
      )}
      <h3 className="font-subtitle2">{t(feature.title)}</h3>
      <p className="font-body4">{t(feature.description)}</p>
    </div>
  );
};

export default FeaturesSectionItem;
